module.exports = __webpack_public_path__ + "static/media/dash-2.08fdd6d8.svg";